import React, { Component } from 'react';

import { correctOrphanWordInSentence } from '../../../utils/textHelpers';
import Text, { getText } from '../../../components/Text';

class ThankYou extends Component {
  componentDidMount() {
    // The view is rendered INSIDE the flinks iframe after workflow completion as a standalone page.
    import('./ThankYou.scss'); // eslint-disable-line
  }

  render() {
    return (
      <div className="thank-you-screen">
        <h2><Text value="Thank You" /></h2>
        <p>
          { correctOrphanWordInSentence(getText('Your account was successfully connected!')) }
        </p>
        <img
          alt={getText('Thank You')}
          className="thank-you-graphic"
          src="/images/img-thankyou.png"
          srcSet="/images/img-thankyou@2x.png 2x, /images/img-thankyou@2x.png 3x"
        />
        <p>
          { correctOrphanWordInSentence(getText('Please wait while we are redirecting you to the next step')) }
        </p>
      </div>
    );
  }
}

export default ThankYou;
